import { Injectable } from '@angular/core';
import { Http, Headers, Response } from '@angular/http';

import { Observable } from 'rxjs';
import 'rxjs/add/operator/map'
import * as myGlobals from '../globals';
import { PlatformLocation } from '@angular/common';
@Injectable()

export class AuthenticationService {
    public token: string;
    public locationHost: any;
    public user_status: string;
    public locationOrigin: any;

    // public apiUrl: string = environment.apiUrl;
    //console.log(this.apiUrl);
    constructor(private http: Http, platformLocation: PlatformLocation) {
        // set token if saved in local storage
        var currentUser = JSON.parse(localStorage.getItem('currentUser'));
        this.token = currentUser && currentUser.token;
        this.user_status = currentUser && currentUser.status;
        this.locationHost = (platformLocation as any).location.hostname;

        let locationPathname = (platformLocation as any).location.pathname;
        this.locationOrigin = locationPathname ? (platformLocation as any).location.origin + locationPathname : (platformLocation as any).location.origin + '/';
    }

    private headers = new Headers({ 'Content-Type': 'application/json' });

    login(email: string, password: string): Observable<boolean> {
        this.headers.append('Content-Type', 'application/x-www-form-urlencoded;charset=UTF-8');
        return this.http.post(myGlobals.apiUrl + '/login', JSON.stringify({ email: email, password: password }), { headers: this.headers })

            .map((response: Response) => {
                // login successful if there's a jwt token in the response
                let token = response.json() && response.json().token;
                let role = response.json() && response.json().role;
                if (token) {
                    // set token property
                    this.token = token;

                    // store username and jwt token in local storage to keep user logged in between page refreshes
                    localStorage.setItem('currentUser', JSON.stringify({ email: email, role: role, token: token }));

                    // return true to indicate successful login
                    return true;
                } else {
                    // return false to indicate failed login
                    return false;
                }
            });
    }

    logout(): void {
        // clear token remove user from local storage to log user out
        localStorage.clear();
        this.token = null;
    }


    register(form): Observable<boolean> {
        this.headers.append('Content-Type', 'application/x-www-form-urlencoded;charset=UTF-8');
        return this.http.post(myGlobals.apiUrl + '/register', JSON.stringify(form), { headers: this.headers })

            .map((response: Response) => {
                // login successful if there's a jwt token in the response
                let status = response.json() && response.json().status;
                if (status) {

                    return true;
                } else {
                    return false;
                }
            });
    }

    userLogin(email: string, password: string): Observable<boolean> {
        this.headers.append('Content-Type', 'application/x-www-form-urlencoded;charset=UTF-8');
        return this.http.post(myGlobals.apiUrl + '/userLogin', JSON.stringify({ email: email, password: password }), { headers: this.headers })

            .map((response: Response) => {
                // login successful if there's a jwt token in the response
                let token = response.json() && response.json().token;
                let role = response.json() && response.json().role;
                let status = response.json() && response.json().status;
                let county = response.json() && response.json().county;
                let zip = response.json() && response.json().zip;
                if (token) {
                    // set token property
                    this.token = token;
                    // set user status property
                    this.user_status = status;

                    // store username and jwt token in local storage to keep user logged in between page refreshes
                    localStorage.setItem('currentUser', JSON.stringify({ email: email, role: role, status: status, token: token, county: county, zip: zip }));

                    // return true to indicate successful login
                    return true;
                } else {
                    // return false to indicate failed login
                    return false;
                }
            });
    }

    isEmailRegisterd(email): Observable<boolean> {
        this.headers.append('Content-Type', 'application/x-www-form-urlencoded;charset=UTF-8');
        return this.http.post(myGlobals.apiUrl + '/checkDuplicateUser', JSON.stringify({ email: email }), { headers: this.headers })
            .map((response: Response) => {

                let res = response.json();
                if (res == 1) {
                    return true;
                } else {
                    return false;
                }
            });
    }

    isUsernameRegisterd(username): Observable<boolean> {
        this.headers.append('Content-Type', 'application/x-www-form-urlencoded;charset=UTF-8');
        return this.http.post(myGlobals.apiUrl + '/checkDuplicateUserName', JSON.stringify({ username: username }), { headers: this.headers })
            .map((response: Response) => {

                let res = response.json();
                if (res == 1) {
                    return true;
                } else {
                    return false;
                }
            });
    }

    isRegisteredUser(email, role_id): Observable<boolean> {
        this.headers.append('Content-Type', 'application/x-www-form-urlencoded;charset=UTF-8');
        return this.http.post(myGlobals.apiUrl + '/checkRegisteredUser', JSON.stringify({ email: email, role_id: role_id }), { headers: this.headers })
            .map((response: Response) => {

                let res = response.json();
                if (res == 1) {
                    return true;
                } else {
                    return false;
                }
            });
    }

    isLoggedIn() {

        var currentUser = JSON.parse(localStorage.getItem('currentUser'));
        let token = currentUser && currentUser.token;
        let role = currentUser && currentUser.role;

        if (token) {
            if (role == 1) {
                return true;
            } else {
                return false;
            }
        } else {
            localStorage.clear();
            this.token = null;
        }
    }

    isUserLoggedIn() {

        var currentUser = JSON.parse(localStorage.getItem('currentUser'));
        let token = currentUser && currentUser.token;
        let role = currentUser && currentUser.role;

        if (token) {
            if (role == 2) {
                return true;
            } else {
                return false;
            }
        } else {
            localStorage.clear();
            this.token = null;
        }
    }

    skipLogin(): Observable<boolean> {
        this.headers.append('Content-Type', 'application/x-www-form-urlencoded;charset=UTF-8');
        return this.http.post(myGlobals.apiUrl + '/skipLogin', { headers: this.headers })

            .map((response: Response) => {
                // login successful if there's a jwt token in the response
                let token = response.json() && response.json().token;
                let role = response.json() && response.json().role;
                let email = response.json() && response.json().email;
                let status = response.json() && response.json().status;
                if (token) {
                    // set token property
                    this.token = token;
                    // set user status property
                    this.user_status = status;

                    // store username and jwt token in local storage to keep user logged in between page refreshes
                    localStorage.setItem('currentUser', JSON.stringify({ email: email, role: role, status: status, token: token }));

                    // return true to indicate successful login
                    return true;
                } else {
                    // return false to indicate failed login
                    return false;
                }
            });
    }

    referWebInfo(post) {
        this.headers.append('Content-Type', 'application/x-www-form-urlencoded;charset=UTF-8');
        // this. headers.append('Authorization', 'Bearer eyJ0eXAiOiJKV1QiLCJhbGciOiJIUzI1NiJ9.eyJzdWIiOjEsImlzcyI6Imh0dHA6Ly9sYXNvLmxvY2FsL3NlcnZlci9hcGkvbG9naW4iLCJpYXQiOjE1MjY0NjM3MjQsImV4cCI6MTUyNjU1MDEyNCwibmJmIjoxNTI2NDYzNzI0LCJqdGkiOiJnYWhHaDR4TFdJRksxOFBEIn0.G0rzjvrtJSjjdhpIXUVw18XBrRbTm5l5kM9TBv5IosA ');

        let api = this.locationHost == 'laso.local' || this.locationHost == 'localhost' ? '/home/callToStaging' : '/referWebInfo';
        return this.http.post(myGlobals.apiUrl + api, JSON.stringify(post), { headers: this.headers })

            .map((response) => {
                if (response['_body']) {
                    return response.json();
                } else {
                    return [];
                }
            });
    }

    forgotPassword(form) {
        form['href'] = this.locationOrigin;
        this.headers.append('Content-Type', 'application/x-www-form-urlencoded;charset=UTF-8');
        return this.http.post(myGlobals.apiUrl + '/forgotPassword', JSON.stringify(form), { headers: this.headers })

            .map((response: Response) => {
                // login successful if there's a jwt token in the response
                let status = response.json();
                return status;
            });
    }

}



// WEBPACK FOOTER //
// /var/www/html/LASO/laso-client/src/app/_services/authentication.service.ts